import React from "react";
import PropTypes from "prop-types";
import {
  MdKeyboardDoubleArrowLeft,
  MdKeyboardDoubleArrowRight,
} from "react-icons/md";

const Pagination = ({
  setItemsPerPage,
  currentPage,
  setCurrentPage,
  itemsPerPage,
  totalPages,
  totalItems
}) => {
  const onItemsPerPageChange = (value) => {
    setItemsPerPage(parseInt(value));
    setCurrentPage(1); 
  };

  const onPreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const onNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  return (
    <div className="pagination-container">
      <div className="pagination-content">
        <div className="items-per-page">
          <span className="label">Show</span>
          <select 
            value={itemsPerPage} 
            onChange={(e) => onItemsPerPageChange(e.target.value)}
            className="items-select"
          >
            <option value="10">10</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
          <span className="label">
            Entries (Total: {totalItems})
          </span>
        </div>
        <div className="page-controls">
          <button
            onClick={onPreviousPage}
            className="page-btn"
            disabled={currentPage === 1}
          >
            <MdKeyboardDoubleArrowLeft /> Previous
          </button>
          
          <span className="page-info">
            {currentPage} of {totalPages}
          </span>
          
          <button
            onClick={onNextPage}
            className="page-btn"
            disabled={currentPage === totalPages}
          >
            Next <MdKeyboardDoubleArrowRight />
          </button>
        </div>
      </div>

      <style jsx>{`
        .pagination-container {
          width: 100%;
          padding: 16px 0;
        }

        .pagination-content {
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          gap: 16px;
        }

        .items-per-page {
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .label {
          font-size: 14px;
          color: #64748b;
        }

        .items-select {
          padding: 6px 12px;
          border: 1px solid #e2e8f0;
          border-radius: 6px;
          font-size: 14px;
          color: #1e293b;
          background: white;
          cursor: pointer;
          transition: border-color 0.2s;
        }

        .items-select:hover {
          border-color: #3b82f6;
        }

        .items-select:focus {
          outline: none;
          border-color: #3b82f6;
        }

        .page-controls {
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .page-btn {
          display: flex;
          align-items: center;
          gap: 4px;
          padding: 8px 16px;
          background: white;
          border: 1px solid #e2e8f0;
          border-radius: 6px;
          font-size: 14px;
          color: #1e293b;
          cursor: pointer;
          transition: all 0.2s;
        }

        .page-btn:hover:not(:disabled) {
          background: #f8fafc;
          border-color: #3b82f6;
        }

        .page-btn:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }

        .page-info {
          font-size: 14px;
          color: #64748b;
          font-weight: 500;
        }

        @media (max-width: 768px) {
          .pagination-content {
            flex-direction: column;
          }
        }
      `}</style>
    </div>
  );
};

Pagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  itemsPerPage: PropTypes.number.isRequired,
  totalItems: PropTypes.number.isRequired,
  setCurrentPage: PropTypes.func.isRequired,
  setItemsPerPage: PropTypes.func.isRequired,
};

export default Pagination;
